import {addCommasToNumber} from "../../utils";

export const offeringSummary = {
    name: 'OFFERING SUMMARY',
    rows: []
};

export const leaseSummary = {
    name: 'LEASE SUMMARY',
    rows: []
};

export const annualizedOperatingData = {
    name: 'ANNUALIZED OPERATING DATA',
    header: ['Year(s)', 'Commencement', 'Annual', 'Increase'],
    rows: []
};

export const netOperatingIncome = {
    name: 'NET OPERATING INCOME',
    value: ''
};

export const getOfferingSummaryData = function (tables) {
    return [{
        label: 'Price',
        value: tables['offering-summary'].rows['price'].getComputedValue(tables).displayValue
    }, {
        label: 'Cap Rate',
        value: `${tables['offering-summary'].rows['cap-rate'].value}%`
    }, {
        label: 'Net Operating Income',
        value: tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).displayValue
    }, {
        label: 'Year Built',
        value: tables['offering-summary'].rows['year-built'].value
    }, {
        label: 'Gross Leasable Area',
        value: `${addCommasToNumber(tables['offering-summary'].rows['gross-leasable-area'].value)} SF`
    }, {
        label: 'Lot Size',
        value: `${tables['offering-summary'].rows['lot-size'].value} Acres`
    }];
};

export const getLeaseSummaryData = function (tables) {
    return [{
        label: 'Lease Term',
        value: tables['lease-summary'].rows['original-lease-term'].getComputedValue(tables).displayValue
    }, {
        label: 'Lease Commencement',
        value: tables['lease-summary'].rows['lease-commencement'].value
    }, {
        label: 'Lease Expiration',
        value: tables['lease-summary'].rows['lease-expiration'].value
    }, {
        label: 'Remaining Term',
        value: tables['lease-summary'].rows['remaining-term'].getComputedValue(tables).displayValue
    }, {
        label: 'Lease Type',
        value: tables['lease-summary'].rows['lease-type'].value
    }, {
        label: 'Roof & Structure',
        value: tables['lease-summary'].rows['roof-and-structure'].getComputedValue(tables).displayValue
    }, {
        label: 'Increases',
        value: tables['lease-summary'].rows['increases'].value
    }, {
        label: 'Options',
        value: tables['lease-summary'].rows['options'].value
    }];
};

export const getAnnualizedOperatingData = function (tables) {
    // 0 - Years     1 - Commencement     2 - Annual     3 - Increase
    const rows = tables['annualized-operating-data'].rows;
    return Object.keys(rows)
        .filter(key => rows[key].valueCells[0].value)
        .map(key => {
            return {
                valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                    if (rows[key].valueCells[cellIndex].editable)
                        return {
                            value: rows[key].valueCells[cellIndex].value
                        };
                    return {
                        value: rows[key].valueCells[cellIndex].getComputedValue(tables, key).displayValue
                    }
                })
            }
    });
};

export const getNetOperatingIncomeData = function (tables) {
    return tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).displayValue;
};